export default __webpack_public_path__ + "static/media/sewing.5ab9d87f.jpg";